import EmployeeFinancialService from "../service/EmployeeFinancialService";
import {
  POST_PAYMENT_REQUEST,
  POST_PAYMENT_SUCCESS,
  POST_PAYMENT_FAIL,

  POST_WELFARE_BENEFITS_REQUEST,
  POST_WELFARE_BENEFITS_SUCCESS,
  POST_WELFARE_BENEFITS_FAIL,

  POST_IMPORTANT_INFORMATION_REQUEST,
  POST_IMPORTANT_INFORMATION_SUCCESS,
  POST_IMPORTANT_INFORMATION_FAIL,

  GET_PAYMENT_REQUEST,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_FAIL,

  GET_WELFARE_BENEFITS_REQUEST,
  GET_WELFARE_BENEFITS_SUCCESS,
  GET_WELFARE_BENEFITS_FAIL,

  GET_IMPORTANT_INFORMATION_REQUEST,
  GET_IMPORTANT_INFORMATION_SUCCESS,
  GET_IMPORTANT_INFORMATION_FAIL,
} from "../constants/EmployeeFinancialConstants";

// ── post actions ────────────────────────────────────────────
export const postPayment = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_PAYMENT_REQUEST });
    const response = await EmployeeFinancialService.postPayment(data);
    dispatch({
      type: POST_PAYMENT_SUCCESS,
      payload: response,
    });
    console.log("Inserted Successfully:", response);
    return { payload: response };
  } catch (error) {
    console.error("Error in postPayment Action:", error);
    dispatch({
      type: POST_PAYMENT_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Payment",
    });
  }
};

export const postWelfareBenefits = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_WELFARE_BENEFITS_REQUEST });
    const response = await EmployeeFinancialService.postWelfareBenefits(data);
    dispatch({
      type: POST_WELFARE_BENEFITS_SUCCESS,
      payload: response,
    });
    console.log("Inserted Successfully:", response);
    return { payload: response };
  } catch (error) {
    console.error("Error in postWelfareBenefits Action:", error);
    dispatch({
      type: POST_WELFARE_BENEFITS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Welfare Benefits",
    });
  }
};

export const postImportantInformation = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_IMPORTANT_INFORMATION_REQUEST });
    const response = await EmployeeFinancialService.postImportantInformation(data);
    dispatch({
      type: POST_IMPORTANT_INFORMATION_SUCCESS,
      payload: response,
    });
    console.log("Inserted Successfully:", response);
    return { payload: response };
  } catch (error) {
    console.error("Error in postImportantInformation Action:", error);
    dispatch({
      type: POST_IMPORTANT_INFORMATION_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Important Information",
    });
  }
};

// ── get actions ─────────────────────────────────────────────
export const getPayment = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_PAYMENT_REQUEST });
    const response = await EmployeeFinancialService.getPayment(serviceNo);
    dispatch({
      type: GET_PAYMENT_SUCCESS,
      payload: response,
    });
    return { payload: response };
  } catch (error) {
    dispatch({
      type: GET_PAYMENT_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Fetch Payment",
    });
  }
};

export const getWelfareBenefits = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_WELFARE_BENEFITS_REQUEST });
    const response = await EmployeeFinancialService.getWelfareBenefits(serviceNo);
    dispatch({
      type: GET_WELFARE_BENEFITS_SUCCESS,
      payload: response,
    });
    return { payload: response };
  } catch (error) {
    dispatch({
      type: GET_WELFARE_BENEFITS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Fetch Welfare Benefits",
    });
  }
};

export const getImportantInformation = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_IMPORTANT_INFORMATION_REQUEST });
    const response = await EmployeeFinancialService.getImportantInformation(serviceNo);
    dispatch({
      type: GET_IMPORTANT_INFORMATION_SUCCESS,
      payload: response,
    });
    return { payload: response };
  } catch (error) {
    dispatch({
      type: GET_IMPORTANT_INFORMATION_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Fetch Important Information",
    });
  }
};